import { render, staticRenderFns } from "./addBtn_nomarl.vue?vue&type=template&id=a1809808&scoped=true"
import script from "./addBtn_nomarl.vue?vue&type=script&lang=js"
export * from "./addBtn_nomarl.vue?vue&type=script&lang=js"
import style0 from "./addBtn_nomarl.vue?vue&type=style&index=0&id=a1809808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1809808",
  null
  
)

export default component.exports